export default {
  getCompanySetting: (state) => state.companySetting,
};
